import { StopContext } from "@vygruppen/vy-train-map";
import { z } from "zod";

export const countryCode = z.enum(["NO", "SE"]);

export type CountryCode = z.infer<typeof countryCode>;

export const getStopContext = (country: CountryCode) => {
  switch (country) {
    case "NO":
      return StopContext.JBV;
    case "SE":
      return StopContext.TVS;
  }
};
